import { IAdaptiveActionCard } from '@ninjacart/nc-nk-core';
import { View } from '@ninjacart/nc-nk-ui';
import { Dimensions } from 'react-native';

export const WebWidget = ({ item }: { item: IAdaptiveActionCard }) => {
  const itemContent = item?.actionData?.content;
  const handleNavWithEvents = (event: any) => {
    event.preventDefault();
    //handle navigation
    //handle events
  };

  return (
    <View
      flex={1}
      onPress={handleNavWithEvents}
      justifyContent="center"
      alignContent="center"
      alignItems="center"
      width={Dimensions.get('window').width ?? itemContent?.dimensions?.width}
      height={itemContent?.dimensions?.height}
      maxWidth={itemContent?.dimensions?.maxWidth}
      maxHeight={itemContent?.dimensions?.maxHeight}
      minHeight={300}
    >
      <iframe
        src={itemContent?.link}
        width={Dimensions.get('window').width ?? itemContent?.dimensions?.width}
        height={itemContent?.dimensions?.height}
        min-height={itemContent?.dimensions?.minHeight}
        max-height={itemContent?.dimensions?.maxHeight}
        frameBorder={0}
      ></iframe>
    </View>
  );
};
